(() => {
  if (window.featuredProductsSliderInitialized === true) {
    return;
  }

  const sliders = document.querySelectorAll(".js-featured-products-slider");

  sliders.forEach((slider) => {
    new Swiper(slider, {
      slidesPerView: 1.6,
      spaceBetween: 16,
      loop: true,
      breakpoints: {
        1024: {
          slidesPerView: 4,
          navigation: {
            nextEl: slider.querySelector(".swiper-button-next"),
            prevEl: slider.querySelector(".swiper-button-prev"),
          },
        },
      },
    });
  });

  window.featuredProductsSliderInitialized = true;
})();
